import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import MaskedInput  from 'react-text-mask'
import PropTypes from 'prop-types'

class MaskedField extends Component {
    constructor(props){
        super(props)
        this.state = {
            textmask: this.props.value,
            mask: this.props.mask
        };
    }

    TextMaskCustom = (props) => {
        const { inputRef, ...other } = props;
        return (
            <MaskedInput
            {...other}
            ref={inputRef}
            mask={this.state.mask}
            placeholderChar={'\u2000'}
            />
        );
    }

    handleChange = (name, onChangeEvent) => event => {
        if(onChangeEvent != null) {
            onChangeEvent(event);
        }
        this.setState({
            [name]: event.target.value,
        });
    }

    render() {
        return (
            <TextField label={this.props.label} name={this.props.id}
                className={this.props.className}
                InputProps={{
                    inputComponent: this.TextMaskCustom,
                    value: this.state.textmask,
                    onChange: this.handleChange('textmask', this.props.onChange),
                }}/>
        );
    }
}

MaskedField.propTypes= {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    mask: PropTypes.array.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
}

export default MaskedField


// WEBPACK FOOTER //
// ./src/components/custom/MaskedField.js